import React from 'react';
import { t } from "i18next";
import GlobalModal from "../../../components/UI/Popups/GlobalModal/GlobalModal";

const ConfirmationModals = ({
    showUpgradeModal,
    showDowngradeModal,
    selectedPlan,
    setShowUpgradeModal,
    setShowDowngradeModal,
    handleProceedUpgrade,
    handleProceedDowngrade
}) => {
    return (
        <>
            {/* Upgrade Confirmation Modal */}
            <GlobalModal
                show={showUpgradeModal}
                onClose={() => setShowUpgradeModal(false)}
                title={t('general.subscription.upgrade')}
                message={`You're about to upgrade your current plan to ${selectedPlan?.name}. You'll be redirected to the payment page to complete the process.`}
                primaryButtonText={t('general.UI.proceed', "Proceed")}
                secondaryButtonText={t('general.UI.cancel', "Cancel")}
                primaryButtonAction={handleProceedUpgrade}
                secondaryButtonAction={() => setShowUpgradeModal(false)}
            />

            {/* Downgrade Confirmation Modal */}
            <GlobalModal
                show={showDowngradeModal}
                onClose={() => setShowDowngradeModal(false)}
                title={selectedPlan?.priceId === 'free'
                    ? t('cancelSubscription.title', "Cancel Subscription")
                    : t('subscription.downgrade', "Downgrade")}
                message={selectedPlan?.priceId === 'free'
                    ? `You're about to cancel your subscription. After cancellation, the Free plan will automatically be activated.`
                    : `You're about to downgrade your current plan to ${selectedPlan?.name}. This change will take effect from your next billing date.`}
                primaryButtonText={t('general.UI.proceed', "Proceed")}
                secondaryButtonText={t('general.UI.cancel', "Cancel")}
                primaryButtonAction={handleProceedDowngrade}
                secondaryButtonAction={() => setShowDowngradeModal(false)}
            />
        </>
    );
};

export default ConfirmationModals; 